import { useState } from "react";
import { useEditor } from "@craftjs/core";
import { Collapse } from "@mui/material";

import CustomHero from "./hero/CustomHero";
import FeaturedCarousel from "./carousel/featured/FeaturedCarousel";
import CategoryCarousel from "./carousel/category/CategoryCarousel";
import PortraitCarousel from "./carousel/portrait/PortraitCarousel";
import PersistentCarousel from "./carousel/persistent/PersistentCarousel";
import BasicCarousel from "./carousel/basic/BasicCarouselBuilderComponent";
import EventHero from "@components/carousel/hero/EventHero";
import BasicBanner from "./banner/BasicBanner";
import { useThemeStore } from "@state/theme";

const DragSvg = () => {
  return (
    <svg
      viewBox="0 0 20 20"
      width="12"
      fill="currentColor"
    >
      <path d="M7 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 2zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 7 14zm6-8a2 2 0 1 0-.001-4.001A2 2 0 0 0 13 6zm0 2a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 8zm0 6a2 2 0 1 0 .001 4.001A2 2 0 0 0 13 14z"></path>
    </svg>
  );
};

const Toolbox = () => {
  const { connectors } = useEditor();
  const backgroundColor = useThemeStore(({ primaryColor }) => primaryColor);

  return (
    <div className="flex flex-col gap-2">
      <DropDownMenu menuTitle="Hero">
        <div
          ref={(ref: any) => connectors.create(ref, <EventHero />)}
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Event Hero Carousel</span>

          <DragSvg />
        </div>
        <div
          ref={(ref: any) => connectors.create(ref, <CustomHero src="https://placehold.co/1920x1080" />)}
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Custom Hero</span>

          <DragSvg />
        </div>
      </DropDownMenu>
      <DropDownMenu menuTitle="Carousel">

        <div
          ref={(ref: any) => connectors.create(ref, <BasicCarousel title="Basic Carousel" />)}
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Basic Carousel</span>
          <DragSvg />
        </div>

        <div
          ref={(ref: any) =>
            connectors.create(
              ref,
              <FeaturedCarousel
                title="Featured Carousel"
                description="Laborum culpa laborum enim incididunt."
                showActionButton
                actionButtonText="Related Events"
              />,
            )
          }
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Featured Carousel</span>
          <DragSvg />
        </div>

        <div
          ref={(ref: any) =>
            connectors.create(
              ref,
              <CategoryCarousel
                title="Category Carousel"
              />,
            )
          }
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Category Carousel</span>
          <DragSvg />
        </div>

        <div
          ref={(ref: any) => connectors.create(ref, <PortraitCarousel title="Portrait Carousel" />)}
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Portrait Carousel</span>
          <DragSvg />
        </div>
      </DropDownMenu>

      {/* Banner */}
      <DropDownMenu menuTitle="Banners">
        <div
          ref={(ref: any) =>
            connectors.create(
              ref,
              <BasicBanner
                title="Basic Banner"
                description="Laborum culpa laborum enim incididunt."
                actionButtonText="Learn More"
                showActionButton
                backgroundColor={backgroundColor}
              />,
            )
          }
          className="w-full flex justify-between rounded-sm text-sm text-center text-black p-3 cursor-grab border"
        >
          <span>Basic Banner</span>
          <DragSvg />
        </div>
      </DropDownMenu>
    </div>
  );
};

export default Toolbox;

interface DropDownMenuProps {
  menuTitle: string;
  children: React.ReactNode;
}

const DropDownMenu: React.FC<DropDownMenuProps> = ({ menuTitle, children }) => {
  const [open, setOpen] = useState(true);

  const handleClick = () => {
    setOpen(!open);
  };

  return (
    <div>
      <div
        className="w-full flex items-center pb-2 pt-1 pl-1 justify-between text-xs font-light uppercase text-gray-900"
        onClick={handleClick}
      >
        {menuTitle}
        <svg
          className={`h-5 w-5 ${open && "transform rotate-180"} text-gray-400`}
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
          fill="currentColor"
          aria-hidden="true"
        >
          <path
            fillRule="evenodd"
            d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z"
            clipRule="evenodd"
          />
        </svg>
      </div>

      <Collapse
        in={open}
        timeout="auto"
        unmountOnExit
      >
        <div
          role="menu"
          aria-orientation="vertical"
          aria-labelledby="options-menu"
          className="flex flex-col gap-3"
        >
          {children}
        </div>
      </Collapse>
    </div>
  );
};
